import { Project, STORE_NEWS_LIST_SIZE, ContentType } from 'common/constants'

export enum FashionBrandStoreTab {
  'NEWS' = 'NEWS',
  'PRODUCT' = 'PRODUCT',
  'EVENT' = 'EVENT',
}

type fashionBrandStoreTabConfig = {
  [key in FashionBrandStoreTab]?: {
    title: string
    path: string
    className: string
    clickCode: string
    contentType?: ContentType
    pageSize?: { [key in Project]?: number }
  }
}

const fashionBrandStoreTabConfig: fashionBrandStoreTabConfig = {
  NEWS: {
    title: 'NEWS',
    path: '/news',
    className: 'news',
    clickCode: 'new',
    pageSize: {
      pc: 12,
      mobile: 5,
    },
  },
  PRODUCT: {
    title: 'PRODUCT',
    path: '/product',
    className: 'product',
    clickCode: 'product',
    pageSize: {
      pc: 20,
      mobile: 10,
    },
  },
  EVENT: {
    title: 'EVENT',
    path: '/event',
    className: 'event',
    clickCode: 'event',
    contentType: ContentType.BRAND_EVENT,
    pageSize: {
      pc: 12,
      mobile: 5,
    },
  },
}

export const getFashionBrandStoreTitle = (id: FashionBrandStoreTab) => {
  return fashionBrandStoreTabConfig[id] && fashionBrandStoreTabConfig[id].title
}

export const getFashionBrandStorePath = (id: FashionBrandStoreTab) => {
  return fashionBrandStoreTabConfig[id] && fashionBrandStoreTabConfig[id].path
}

export const getFashionBrandStoreClassName = (id: FashionBrandStoreTab) => {
  return fashionBrandStoreTabConfig[id] && fashionBrandStoreTabConfig[id].className
}

export const getFashionBrandStoreClickCode = (id: FashionBrandStoreTab): string => {
  return fashionBrandStoreTabConfig[id] && fashionBrandStoreTabConfig[id].clickCode
}

export const getFashionBrandStoreContentType = (id: FashionBrandStoreTab) => {
  return (fashionBrandStoreTabConfig[id] && fashionBrandStoreTabConfig[id].contentType) || null
}

export const getFashionBrandStorePageSize = (id: FashionBrandStoreTab) => {
  return (
    fashionBrandStoreTabConfig[id] &&
    fashionBrandStoreTabConfig[id].pageSize &&
    fashionBrandStoreTabConfig[id].pageSize[process.env.PROJECT_NAME]
  )
}
